module.exports = __webpack_public_path__ + "static/media/timer.4853c49e.svg";